<ft-modal-overlay [open]="open()">
    @if (open()) {
        <ft-modal-chrome-ng
            modalClass="guestInfoModal"
            [headerText]="'flipto.account.people.details.EditDetails' | translate"
            size="sm"
            [doneVisible]="true"
            [cancelVisible]="true"
            [footerVisible]="true"
            [footerCancelVisible]="false"
            (done)="save()"
            (cancel)="cancel()"
        >
            <div class="modal-section-heading">{{ 'flipto.account.people.details.GuestNameHeading' | translate }}</div>
            <div class="modal-panel modal-panel-trans modal-panel-input">
                <div class="ft-row">
                    <div class="ft-col-50 input-left">
                        <input name="first" [placeholder]="'flipto.account.people.details.FirstNamePlaceholder' | translate" [(ngModel)]="first" required>
                    </div>
                    <div class="ft-col-50 input-right">
                        <input name="last" [placeholder]="'flipto.account.people.details.LastNamePlaceholder' | translate" [(ngModel)]="last" required>
                    </div>
                </div>
            </div>

            @if (hasStayDates) {
                <div class="modal-section-heading">{{ 'flipto.account.people.details.StayDateHeading' | translate }}</div>
                <div class="modal-panel modal-panel-input">
                    <ft-date-range-picker-ng [(startDate)]="startDate" [(endDate)]="endDate" />
                </div>
            }

            @if (profileImageUrl) {
                <div class="modal-section-heading">{{ 'flipto.account.people.details.ProfileImageHeading' | translate }}</div>
                <div class="modal-panel modal-panel-input">
                    @if (!removingProfileImage) {
                        <div class="ft-row">
                            <div class="ft-col-66">
                                <img [src]="profileImageUrl" class="profile-image-guest-details" />
                            </div>
                            <div class="ft-col-33">
                                <div class="remove-image-button">
                                    <a (click)="removeImage()">{{ 'flipto.account.people.details.RemoveImage' | translate }}</a>
                                    <br />
                                </div>
                            </div>
                        </div>
                    } @else {
                        <div class="imageNotAvail">
                            <span>{{ 'flipto.account.people.details.ImageWillBeRemoved' | translate }}</span>
                        </div>
                    }
                </div>
            }

            <div class="modal-section-heading">{{ 'flipto.account.people.details.EmailHeading' | translate }}</div>
            <div class="modal-panel modal-panel-input">
                <input type="email" name="email" [placeholder]="'flipto.account.people.details.EmailPlaceholder' | translate" [(ngModel)]="email" required>
            </div>
        </ft-modal-chrome-ng>
    }
</ft-modal-overlay>
